module.exports = __webpack_public_path__ + "img/hr-train-wheels-shadow-6.aea375eb.png";